import { Tooltip, type TooltipProps, tooltipClasses } from "@mui/material";
import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "CerCardStyled";

export const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  doneChip: `${PREFIX}-doneChip`,
};

export const CerCardStyled = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: "flex",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    justifyContent: "space-between",
    alignItems: "center",
    [`&.${classes.icon}`]: {
      padding: theme.spacing(1),
    },
    "& .MuiChip-label": {
      fontWeight: 600,
      fontSize: 12,
    },
    [`& .${classes.doneChip}`]: {
      color: theme.palette.gray.dark,
      border: `1px solid ${theme.palette.gray.dark}`,
    },
  },
}));

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    color: "black",
    boxShadow: theme.shadows[1],
    minWidth: "400px",
    ...theme.typography.body1,
  },
}));
